class LazyWufooEmbed extends HTMLElement {
  constructor() {
    super();
    this.loaded = false;
    this.formIframeCheckInterval = null;
  }

  connectedCallback() {
    const user = this.getAttribute('user');
    const form = this.getAttribute('form');

    if (!user || !form) {
      console.warn('Missing "user" or "form" attribute on <lazy-wufoo-embed>');
      return;
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.loaded) {
            this.loadWufoo(user, form);
            this.loaded = true;
            obs.disconnect();
          }
        });
      });

      observer.observe(this);
    } else {
      this.loadWufoo(user, form);
    }
  }

  loadWufoo(user, form) {
    const containerId = `wufoo-${form}`;
    this.innerHTML = `<div id="${containerId}">Loading form...</div>`;

    const s = document.createElement('script');
    s.src = 'https://secure.wufoo.com/scripts/embed/form.js';
    s.async = true;

    s.onload = () => {
      try {
        const options = {
          userName: user,
          formHash: form,
          autoResize: true,
          height: '410',
          async: true,
          host: 'wufoo.com',
          header: 'show',
          ssl: true
        };

        const wf = new WufooForm();
        wf.initialize(options);
        wf.display();

        // this.trackWufooSubmission(containerId);

      } catch (e) {
        console.error(`[WufooEmbed] Error initializing WufooForm:`, e);
      }
    };

    document.body.appendChild(s);
  }

  trackWufooSubmission(containerId) {
    const checkInterval = setInterval(() => {
      const iframe = document.querySelector(`#${containerId} iframe`);
      if (!iframe) return;

      try {
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        const confirmation = doc.querySelector('.wufoo .success');

        if (confirmation && confirmation.textContent.includes('Thank')) {
          clearInterval(checkInterval);

          // ✅ Fire Google Analytics 4 event
          if (typeof gtag === 'function') {
            gtag('event', 'form_submit', {
              form_name: 'Wufoo Contact Form',
              event_category: 'form',
              event_label: 'Wufoo embedded success',
              value: 1
            });
          }

          console.log('✅ Tracked Wufoo form submission');
        }
      } catch (e) {
        // Likely a CORS error while the form is loading
        // Safe to ignore and continue polling
      }
    }, 1000); // check every second
  }
}

customElements.define('lazy-wufoo-embed', LazyWufooEmbed);
